import React from 'react';
export const withPropsTransformer = (propsTransformer) => (WrappedComponent) => {
    const ComponentWithPropsTransformer = (props) => {
        const wrappedComponentProps = propsTransformer(props);
        return (
        // @ts-ignore-next-line
        React.createElement(WrappedComponent, Object.assign({}, wrappedComponentProps)));
    };
    return ComponentWithPropsTransformer;
};
//# sourceMappingURL=withPropsTransformer.js.map